<template>
  <v-dialog
    v-if="!!assignActionVersion"
    :value="!!assignActionVersion"
    persistent
    @keydown.esc="done(false)"
    width="500"
  >
    <v-card :loading="$apollo.loading || loading">
      <v-card-title class="headline grey lighten-2" primary-title>
        {{ $t(`mentorship.actions.changeVersion.title`) }}
      </v-card-title>
      <v-card-text>
        <div class="my-2">
          {{ $t(`mentorship.actions.changeVersion.assignedVersions`) }}:
          <v-chip
            small
            v-for="version in assignActionVersion.assignedVersions"
            :key="version.id"
            :close="version.content.every((c) => c.signatures.length == 0)"
            close-icon="delete_forever"
            @click:close="deleteAssignedVersion(version.assignedId)"
          >
            {{ version.revision }} ({{ version.created | date }})
          </v-chip>
        </div>

        <v-autocomplete
          class="mt-0 pt-0"
          v-model="selectedVersion"
          :items="versions"
          required
          chips
          deletable-chips
          :item-text="
            (e) => `${e.revision} (${$options.filters.date(e.created)})`
          "
          return-object
        />
      </v-card-text>

      <v-divider />
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="grey" text @click="done">{{ $t("dialog.cancel") }}</v-btn>

        <v-btn
          color="primary"
          text
          @click="assignMentorshipActionsVersion"
          :loading="$apollo.loading || loading"
          >{{ $t("dialog.assign") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

import AssignMentorshipActionVersionQuery from "@/graphql/mutation/mentorshipActions/AssignMentorshipActionVersion.gql";
import DeleteAssignedMentorshipActionVersionQuery from "@/graphql/mutation/mentorshipActions/DeleteAssignedMentorshipActionVersion.gql";
import MentorshipActionByTagIdWoContentQuery from "@/graphql/queries/MentorshipActionByTagIdWoContent.gql";

export default {
  props: {
    assignActionVersion: {
      type: Object,
      validator: function(value) {
        if (value.id && value.tagId) {
          return true;
        }
        return false;
      },
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      selectedVersion: null,
    };
  },

  computed: {
    ...mapGetters(["role"]),
  },
  methods: {
    deleteAssignedVersion(assignedVersionId) {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: DeleteAssignedMentorshipActionVersionQuery,
          variables: {
            assignedMentorshipActionVersionId: assignedVersionId,
          },
        })
        .catch((err) => {
          this.$store.commit("push_global_message", {
            color: "error",
            text: err,
          });
        })
        .finally(() => {
          this.loading = false;
          this.done(true);
        });
    },
    assignMentorshipActionsVersion() {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: AssignMentorshipActionVersionQuery,
          variables: {
            mentorshipId: this.assignActionVersion.id,
            mentorshipActionVersionId: this.selectedVersion.id,
          },
        })
        .catch((err) => {
          this.$store.commit("push_global_message", {
            color: "error",
            text: err,
          });
        })
        .finally(() => {
          this.loading = false;
          this.done(true);
        });
    },
    done(isUpdated = false) {
      this.$emit("done", isUpdated);
    },
  },
  apollo: {
    versions: {
      query: MentorshipActionByTagIdWoContentQuery,
      variables() {
        return {
          tagId: this.assignActionVersion.tagId,
        };
      },
      update(res) {
        if (!res || !res.mentorshipAction) {
          return [];
        }

        const versions = res.mentorshipAction.versions.map(
          (version) => version
        );

        const notAddedAndHigherVersions = versions.filter(
          (version) =>
            !this.assignActionVersion.assignedVersions.some(
              (assignedVersion) => version.id <= assignedVersion.id
            )
        );

        if (notAddedAndHigherVersions.length == 0) {
          return [];
        }

        const highestId = Math.max(
          ...notAddedAndHigherVersions.map((version) => version.id)
        );

        const highestVersion = notAddedAndHigherVersions.find(
          (version) => version.id == highestId
        );

        return highestVersion ? [highestVersion] : [];
      },
      skip() {
        return !this.assignActionVersion;
      },
    },
  },
};
</script>
